import { render, staticRenderFns } from "./UpdateCustomerProductDetailsPopUp.vue?vue&type=template&id=cb8a3a20&scoped=true&"
import script from "./UpdateCustomerProductDetailsPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerProductDetailsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomerProductDetailsPopUp.vue?vue&type=style&index=0&id=cb8a3a20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8a3a20",
  null
  
)

export default component.exports